import React from 'react';

export default function DetailSection({ id, title, action, children, variant = 'default' }) {
  return (
    <section aria-labelledby={id} className={`min-w-0 p-4 ${variant === 'paper' ? 'rounded-xl bg-krit-paper text-krit-surface sm:p-7' : 'rounded-2xl border border-krit-line/70 bg-white sm:p-8'}`}>
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3 sm:mb-5">
        <h2 id={id} className={variant === 'paper' ? 'text-[21px] font-black tracking-tight sm:text-[24px]' : 'text-xl font-bold sm:text-2xl'}>{title}</h2>
        {action}
      </div>
      {children}
    </section>
  );
}
